var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00011D",
    fillRule: "evenodd",
    d: "M12,12.000125 L15,15.0001375 L15,17.1211463 L12.75,14.871137 L12.75,22.5001688 L11.25,22.5001688 L11.25,14.871137 L9,17.1211463 L9,15.0001375 L12,12.000125 Z M11.25,4.50001875 C14.04375,4.50001875 16.3905,6.42152676 17.055,9.00978754 C17.12025,9.00753753 17.184,9.0000375 17.25,9.0000375 C20.14425,9.0000375 22.5,11.3550473 22.5,14.2500594 C22.5,16.8900704 20.54025,19.0740795 18,19.440081 L18,19.440081 L18,17.9243247 C19.70925,17.5763232 21,16.0613169 21,14.2500594 C21,12.1823008 19.31775,10.5000437 17.25,10.5000437 C17.19525,10.5045438 17.15325,10.5075438 17.1105,10.5090438 L17.1105,10.5090438 L15.903,10.554044 L15.60225,9.3832891 C15.09,7.3912808 13.3005,6.00001875 11.25,6.00001875 C8.781,6.00001875 6.7695,7.99953333 6.75,10.4640436 C6.7515,10.4947937 6.753,10.5247939 6.753,10.555544 L6.753,10.555544 L6.7635,11.8342993 L5.502,12.0465502 C4.0515,12.2903012 3,13.5323064 3,15.0000625 C3,16.6545694 4.34625,18.000075 6,18.000075 L6,18.000075 L6,19.5000812 C3.51825,19.5000812 1.5,17.4818228 1.5,15.0000625 C1.5,12.7733032 3.12675,10.9245455 5.253,10.567544 C5.253,10.5450439 5.25,10.5225438 5.25,10.5000437 C5.25,7.19177997 7.94175,4.50001875 11.25,4.50001875 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/Cloud Upload.1feb8d57079ec7c261c6c39590676c0a.svg";
export { ForwardRef as ReactComponent };